export default __webpack_public_path__ + "static/media/indicator-sect4-after-2.d5c0f431.svg";